import React, { useEffect, useState } from 'react';
import scannerApi from './scannerApi';

const Row = ({ label, children }) => (
  <li className="list-group-item">
    <div className="small text-muted">{label}</div>
    <div className="fw-bold">{children}</div>
  </li>
);

const List = ({ items }) =>
  items?.length ? (
    <div className="d-flex flex-wrap gap-1 mt-1">
      {items.map((i) => (
        <span key={i.id} className="badge bg-light text-dark border">{i.name}</span>
      ))}
    </div>
  ) : (
    '—'
  );

// The logged-in guard's own details and permission set, exactly as an admin entered them under Users > Security Form.
// Read-only: permissions are changed by an admin.
const SettingsPage = () => {
  const [state, setState] = useState({ loading: true, profile: null, error: '' });

  useEffect(() => {
    scannerApi
      .get('/security/me')
      .then(({ data }) => setState({ loading: false, profile: data.data, error: '' }))
      .catch((e) => setState({ loading: false, profile: null, error: e.response?.data?.message || 'Could not load your details.' }));
  }, []);

  if (state.loading) return <p className="text-muted">Loading…</p>;
  if (state.error) return <div className="alert alert-danger">{state.error}</div>;
  const p = state.profile;

  return (
    <div className="card">
      <div className="card-header py-2 small text-muted">Your details and access, set by an admin</div>
      <ul className="list-group list-group-flush">
        <Row label="Name">{p.name}</Row>
        <Row label="Email">{p.email}</Row>
        <Row label="Phone">{p.phone}</Row>
        <Row label="Venue">{p.venue}</Row>
        <Row label="Zone"><List items={p.zones} /></Row>
        <Row label="Facility"><List items={p.facilities} /></Row>
        <Row label="Transport"><List items={p.transport} /></Row>
        <Row label="Dining"><List items={p.dining} /></Row>
        <Row label="Status">
          <span className={`badge ${p.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>{p.status}</span>
        </Row>
      </ul>
    </div>
  );
};

export default SettingsPage;
